export default __webpack_public_path__ + "static/media/boa-linkedin.cf3f07a1.svg";